import languageMap from './locales';
import type { OptionsArrayKeys } from '@/scripts/extends';
import { OptionsArray } from '@/scripts/extends';
import enUS from 'antd/locale/en_US';
import 'dayjs/locale/en';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import zhTW from 'antd/locale/zh_TW';
import 'dayjs/locale/zh-tw';
import vi from 'antd/locale/vi_VN';
import 'dayjs/locale/vi';

// Map
export { languageMap };

// List
export const languageList = new OptionsArray([
  {
    key: 'en',
    label: 'English',
    antdPackage: enUS,
    dayjsKey: 'en',
  },
  {
    key: 'zh-CN',
    label: '简体中文',
    antdPackage: zhCN,
    dayjsKey: 'zh-cn',
  },
  {
    key: 'zh-TW',
    label: '繁体中文',
    antdPackage: zhTW,
    dayjsKey: 'zh-tw',
  },
  {
    key: 'vi',
    label: 'Tiếng Việt',
    antdPackage: vi,
    dayjsKey: 'vi',
  },
] as const);

export type LanguageListKeys = OptionsArrayKeys<typeof languageList>;

languageList.forEach((item) => {
  if (!(item.value in languageMap)) {
    console.error(
      `The configuration item whose key is '${item.key}' is missing from the language list.`
    );
  }
});
